/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                from 'react';
import { StyledIconInline } from '../StyledIconInline';


/*********************************************************************************
 2. Component
 *********************************************************************************/

const StyledIconHomeHeart = StyledIconInline.extend`
  height: ${props => props.height || '21px'};
  width: ${props => props.width || '24px'};
  transform: translateY(1px);
`;

export const IconHomeHeart = (props) => (
    <StyledIconHomeHeart {...props}>
        <svg viewBox="0 0 24 21" version="1.1" xmlns="http://www.w3.org/2000/svg"
             xmlnsXlink="http://www.w3.org/1999/xlink">
            <g strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round"
               strokeLinejoin="round">
                <polyline points="15.4795 9.4404 15.4795 13.3894 8.4715 13.3894 8.4715 9.4404"/>
                <polygon points="11.034 13.39 12.893 13.39 12.893 10.428 11.034 10.428"/>
                <polyline points="7.7441 10.0146 11.9751 6.5036 16.2071 10.0146"/>
                <path d="M14.5156,8.6113 L14.5156,7.4733"/>
                <path d="M21.5425,2.4062 C19.3325,0.1962 13.9795,-0.0968 12.0015,4.1032 C10.0245,-0.0968 4.6705,
                0.1962 2.4605,2.4062 C-0.1445,4.4712 0.2365,9.1082 2.4475,11.3182 C4.8105,14.2682 9.9285,
                18.4552 11.5195,19.7292 C11.8015,19.9562 12.2015,19.9562 12.4835,19.7292 C14.0755,18.4552 19.1925,
                14.2682 21.5565,11.3182 C23.7665,9.1082 24.1475,4.4712 21.5425,2.4062 Z"/>
            </g>
        </svg>
    </StyledIconHomeHeart>
);



// WEBPACK FOOTER //
// ./src/components/atoms/IconHomeHeart/index.js